/**
 * soleya-header.js
 * Soleya Collection — header JS polish
 *
 * Vessel's header-menu.js handles all ARIA, dropdown open/close,
 * sticky detection, mobile drawer, and cart logic.
 * This file adds only what Vessel does not provide:
 *  - Body scroll class for CSS targeting
 *  - Soleya data attribute on the header element
 *  - Hover-bridge enhancement for the editorial panel
 */
(function () {
  'use strict';

  var hdr = document.getElementById('header-component');
  if (!hdr) return;

  // Mark the header so CSS can target [data-soleya] for safe isolation
  hdr.setAttribute('data-soleya', '');

  // ── Scroll state class ──────────────────────────────────────────
  // Adds .soleya-scrolled to <body> once the page moves past 40px.
  // Used by CSS to handle any scroll-dependent states not covered
  // by Vessel's sticky mechanism.
  var SCROLL_THRESHOLD = 40;
  var scrolled = false;

  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    var isScrolled = y > SCROLL_THRESHOLD;
    if (isScrolled !== scrolled) {
      scrolled = isScrolled;
      document.body.classList.toggle('soleya-scrolled', scrolled);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // initialise immediately

  // ── Dropdown hover bridge ───────────────────────────────────────
  // Vessel adds a CSS ::after bridge on .menu-list__list-item but
  // it relies on --header-padding (16px + 20px = 36px).
  // With our taller panel, we extend this programmatically so the
  // cursor can travel from any point in the nav bar into the panel
  // without the dropdown closing mid-journey.
  // We target only the items that HAVE a submenu (aria-haspopup).
  function enhanceHoverBridge() {
    var items = hdr.querySelectorAll('.menu-list__list-item');
    items.forEach(function (item) {
      var link = item.querySelector('.menu-list__link[aria-haspopup]');
      if (!link) return;

      // Vessel already sets data-safety-box via header-menu.js when
      // the cursor enters the submenu. We extend the bridge height
      // on the list item's ::after via a CSS custom property.
      item.style.setProperty('--sh-bridge-extra', '32px');
    });
  }

  // Run once the Vessel header-menu custom element has initialised
  if (typeof customElements !== 'undefined') {
    customElements.whenDefined('header-menu').then(enhanceHoverBridge);
  } else {
    document.addEventListener('DOMContentLoaded', enhanceHoverBridge);
  }
})();
